<div *ngIf="this.listableListingTimeline" class="listing-container">
  <inline-carousel
    *ngIf="listableListingTimeline.photos.length"
    [alt]="listableListingTimeline.name"
    [photos]="listableListingTimeline.photos"
    [inlineCarouselOptions]="inlineCarouselOptions"
    (clickedIndex)="openFullScreenCarousel($event)"
  ></inline-carousel>
  <div class="listing-content">
  <div class="row">
    <div class=" col-12 col-lg-10 offset-lg-1">

      <div class="row">
        <div class="col-12">
          <h1 class="listing-name">{{ this.listableListingTimeline.title({ includeCommas: true }) }}</h1>
          <span *ngIf="!this.listableListingTimeline.photos.length">Photos Coming Soon!</span>
          <hr>
        </div>
      </div>

      <div class="row">
        <div class="col">

          <div class="title-details-container">

            <div class="row">
              <div class="col-12 col-sm-auto align-self-center">
                <span class="title-price">{{ listableListingTimeline.price() }}</span>
                <span class="status">{{ listableListingTimeline.status() }}</span>
              </div>
              <div class="col-4 col-sm-auto align-self-center">
                <span class="title-detail-container" *ngIf="listableListingTimeline.timelineFieldValue('bedrooms')">
                  <span class="value">{{ listableListingTimeline.timelineFieldValue('bedrooms') }}</span>
                  <span class="label label-text">beds</span>
                </span>
              </div>
              <div class="col-4 col-sm-auto align-self-center">
                <span class="title-detail-container" *ngIf="listableListingTimeline.timelineFieldValue('full-bathrooms')">
                  <span class="value">{{ listableListingTimeline.bathrooms() }}</span>
                  <span class="label label-text">baths</span>
                </span>
              </div>
              <div class="col-4 col-sm-auto align-self-center">
                <span class="title-detail-container" *ngIf="listableListingTimeline.totalFinishedSqft()">
                  <span class="value">{{ listableListingTimeline.totalFinishedSqft() }}</span>
                  <span class="label label-text">sqft</span>
                </span>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-12">
                <savings-link
                  [savingsInCents]="listableListingTimeline.savings_in_cents"
                ></savings-link>
              </div>
            </div>

          </div>

        </div>
      </div>

      <div class="row">
        <div class="col-md-7">
          <marketing-banner
            [listingTimeline]="listableListingTimeline"
          ></marketing-banner>
          <h3 class="secondary-title mt-4">Listing Description:</h3>
          <p class="listing-description">{{ listingDescription() }}</p>
          <listing-map [listingTimeline]="listableListingTimeline" ></listing-map>
        </div>
        <div class="col-md-5 pt-4 pt-md-0">
          <div class="secondary-info-container">
            <h3 class="secondary-title mb-2">Share</h3>
            <share
              [url]="listableListingTimeline.listing_url"
            ></share>
          </div>

          <div class="secondary-info-container">
            <h3 class="secondary-title mb-3">Want to Learn More?</h3>
            <listing-contact
              [primaryAgent]="primaryAgent"
              [timelineId]="timelineId"
            ></listing-contact>
          </div>

          <div *ngIf="isVirtualTourAbsent" class="secondary-info-container">
            <h3 class="secondary-title mb-3">Virtual Tours</h3>
            <div><span>Coming Soon!</span></div>
          </div>

          <div *ngIf="youtubeUrl" class="secondary-info-container" #youtubePlayer>
            <h3 class="secondary-title mb-3">Virtual Tour</h3>
              <div  class="video-container">
                <iframe  [src]="youtubeUrl" frameborder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" class="video">
                </iframe>
            </div>
          </div>

          <div *ngIf="homejab360Url" class="secondary-info-container">
            <h3 class="secondary-title mb-3">Interactive Tour</h3>
              <div class="video-container">
                <iframe [src]="homejab360Url" frameborder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen" class="video">
                </iframe>
            </div>
          </div>

          <div *ngIf="matterportUrl" class="secondary-info-container">
            <h3 class="secondary-title mb-3">3D Interactive Tour</h3>
              <div class="video-container">
                <iframe [src]='matterportUrl' frameborder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen" class="video">
                </iframe>
            </div>
          </div>

          <div *ngIf="homejabVimeoUrl" class="secondary-info-container">
            <h3 class="secondary-title mb-3">Virtual Tour</h3>
              <div class="video-container">
                <iframe [src]='homejabVimeoUrl' frameborder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen" class="video">
                </iframe>
            </div>
          </div>


          <div class="secondary-info-container">
            <h3 class="secondary-title mb-3">Additional Details</h3>

            <div class="property-details-container">
              <div class="property-details-row" *ngIf="listableListingTimeline.timelineFieldValue('property-type')">
                <span class="label-text">Property Type</span>
                <span class="details-value">{{ listableListingTimeline.timelineFieldValue('property-type') }}</span>
              </div>
              <div class="property-details-row" *ngIf="listableListingTimeline.timelineFieldValue('neighborhood')">
                <span class="label-text">Neighborhood</span>
                <span class="details-value">{{ listableListingTimeline.timelineFieldValue('neighborhood') }}</span>
              </div>
              <div class="property-details-row" *ngIf="listableListingTimeline.timelineFieldValue('school-district')">
                <span class="label-text">School District</span>
                <span class="details-value">{{ listableListingTimeline.timelineFieldValue('school-district') }}</span>
              </div>
              <div class="property-details-row" *ngIf="listableListingTimeline.timelineFieldValue('year-built')">
                <span class="label-text">Year Built</span>
                <span class="details-value">{{ listableListingTimeline.timelineFieldValue('year-built') }}</span>
              </div>
              <div class="property-details-row" *ngIf="associationFee">
                <span class="label-text">Association Fees</span>
                <span class="details-value">{{ associationFee }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</div>

<ng-container *ngIf="fullScreenCarousel">
  <full-screen-carousel
  [photos]="listableListingTimeline.photos"
  [clickedIndex]="clickedIndex"
  (onClose)="fullScreenCarousel = false"
  ></full-screen-carousel>
</ng-container>
